<template>
  <section id="RenewalOffer">
    <div id="RenewalOfferAnchor" />
    <b-container>
      <div class="content">
        <div class="title-box renewal-offer">
          <div class="title">United Club<span>Extension Offer</span></div>
        </div>
        <div class="renewal-offer-cnt">
          <div class="renOffBox">
            <div class="renOff-title">
              <img src="~@/assets/svgs/four-pay-icon.svg">
              <p class="two-year">2-Year<br />Extension</p>
            </div>
            <div class="renOff-list">
              <ul>
                <li>Annual 5% escalator</li>
                <li v-if="global.userInfo.accountType == 'priceIncrease'">Price increase spread evenly across contract length</li>
              </ul>
            </div>
          </div>
          <div class="renOffBox">
            <div class="renOff-title">
              <img src="~@/assets/svgs/two-pay-icon.svg">
              <p class="four-year">4-Year<br />Extension</p>
            </div>
            <div class="renOff-list">
              <ul>
                <li v-if="global.userInfo.accountType == 'marketRate'">Price freeze in year 1</li>
                <li>Annual 3% escalator in years 2-4</li>
                <li v-if="global.userInfo.accountType == 'priceIncrease'">Price increase spread evenly across contract length</li>
              </ul>
            </div>
          </div>
          <div class="renOffBox">
            <div class="renOff-title">
              <img src="~@/assets/svgs/pay-in-full-icon.svg">
              <p class="six-year">6-Year<br />Extension</p>
            </div>
            <div class="renOff-list">
              <ul>
                <li v-if="global.userInfo.accountType == 'marketRate'">Price freeze in years 1-2</li>
                <li>Annual 3% escalator in years 3-6</li>
                <li>Enter to win a trip for 2 to a 2025 Denver Broncos road game</li>
                <li>$400 in Broncos Plus credit for the 2025 season</li>
                <li v-if="global.userInfo.accountType == 'priceIncrease'">Price increase spread evenly across contract length</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="pricing">
            <div class="title-cnt">
              <div class="title">United Club Level</div>
              <div class="small-title">Annual United Club Ticket Price (Per Seat)</div>
            </div>
            <div class="renewalOffer-cnt">
              <table class="renewalOfferTable">
                <tr>
                  <td>License Renewal Term</td>
                  <td>2026</td>
                  <td>2027</td>
                  <td>2028</td>
                  <td>2029</td>
                  <td>2030</td>
                  <td>2031</td>
                  <td>2032</td>
                </tr>
                <tr>
                  <td>2-Year Renewal Term</td>
                  <td>{{ global.userInfo.twoYear2026 }}</td>
                  <td>{{ global.userInfo.twoYear2027 }}</td>
                  <td class="expired">Expired</td>
                  <td class="expired">&nbsp;</td>
                  <td class="expired">&nbsp;</td>
                  <td class="expired">&nbsp;</td>
                  <td class="expired">&nbsp;</td>
                </tr>
                <tr>
                  <td>4-Year Renewal Term</td>
                  <td>{{ global.userInfo.fourYear2026 }}</td>
                  <td>{{ global.userInfo.fourYear2027 }}</td>
                  <td>{{ global.userInfo.fourYear2028 }}</td>
                  <td>{{ global.userInfo.fourYear2029 }}</td>
                  <td class="expired">Expired</td>
                  <td class="expired">&nbsp;</td>
                  <td class="expired">&nbsp;</td>
                </tr>
                <tr>
                  <td>6-Year Renewal Term</td>
                  <td>{{ global.userInfo.sixYear2026 }}</td>
                  <td>{{ global.userInfo.sixYear2027 }}</td>
                  <td>{{ global.userInfo.sixYear2028 }}</td>
                  <td>{{ global.userInfo.sixYear2029 }}</td>
                  <td>{{ global.userInfo.sixYear2030 }}</td>
                  <td>{{ global.userInfo.sixYear2031 }}</td>
                  <td class="expired">Expired</td>
                </tr>
              </table>
            </div>
        </div>
      </div>
    </b-container>
  </section>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    name: "RenewalOffer",
    data() {
      return {
        zoneInfo: [],
      }
    },
    computed: {
      ...mapState(["global"])
    },
    mounted() {
      setTimeout(() => {
        console.log('global', this.global);
        this.zoneSetter(this.global.allUserAccs);
      }, 1000);
    },
    methods: {
      calculateYear(year, numb) {
        let newYear = parseInt(year)

        return newYear + numb
      },
      priceChooser(expiration, zone) {
        if (expiration === "2021") {
          return zone.price2021
        } else {
          return zone.price2022
        }
      },
      zoneSetter(zones) {
        this.zoneInfo = zones.reduce((x,y) => x.findIndex(e => e.zoneType == y.zoneType) <0 ? [...x, y] : x, [])
      }
    },
  }
</script>

<style lang="scss" scoped>
  #RenewalOffer {
    position: relative;
    background-color: #F4F4F4;
    width: 100%;
    padding: 85px 0;
    #RenewalOfferAnchor {
      position: absolute;
      top: 0;
      left: 0;
    }
    .content {
      position: relative;
      width: 100%;
      max-width: 1000px;
      margin: 0 auto;
      z-index: 3;
    }
    .title-box {
      width: 100%;
      &.dark-bg {
        .title {
          color: $orange;
          span {
            color: $white;
          }
        }
        .underline {
          background: #021734;
          &.full {
            max-width: 100%;
          }
        }
      }
      &.orange-bg {
        .title {
          color: $white;
          span {
            color: $blue;
          }
        }
        .underline {
          background: #C43A00;
        }
      }
      &.renewal-offer {
        margin-bottom: 50px;
      }
      .title {
        z-index: 2;
        position: relative;
        text-align: left;
        font-size: 22px;
        @include nofex;
        line-height: 31px;
        text-transform: uppercase;
        color: #FF4B00;
        span {
          position: relative;
          display: block;
          font-size: 58px;
          @include nexaBold;
          line-height: 1;
          color: #092244;
        }
      }
      .plan-info {
        max-width: 560px;
        margin: 20px 0 10px;
        p {
          font-size: 14px;
          @include nexaBold;
          line-height: 18px;
          text-align: left;
          color: $white;
          a {
            text-decoration: underline;
            color: $white;
          }
        }
      }
      .underline {
        width: 100%;
        max-width: 470px;
        margin-top: 20px;
        height: 6px;
      }
    }
    .renewal-offer-cnt {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      width: 100%;
      gap: 20px;
      .renOffBox {
        position: relative;
        width: 320px;
        padding: 25px 20px 15px;
        text-align: center;
        background: rgba(235, 235, 235, 0.80);
        .renOff-title {
          position: relative;
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          img {
            width: 45px;
          }
          p {
            margin-top: 10px;
            font-size: 22px;
            @include nexaBold;
            line-height: 21px;
            text-transform: uppercase;
            &.two-year { color: #0B2241; }
            &.four-year { color: $orange; }
            &.six-year { color: #0064B5; }
          }
        }
        .renOff-list {
          margin-top: 20px;
          ul {
            display: inline-block;
            position: relative;
            width: 100%;
            height: auto;
            padding-left: 0;
            text-align: left;
            list-style: outside disc;
            li {
              padding: 3px 0;
              margin-left: 16px;
              @include nexaBold;
              font-size: 12px;
              line-height: 13px;
              color: #0B2241;
              &:first-of-type {
                margin-top: 0;
              }
            }
          }
        }
      }
    }
    .pricing {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin: 15px 0;
      .title-cnt {
        position: relative;
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-between;
        padding: 32px 30px;
        .title {
          margin-right: 100px;
          @include nexaBold;
          font-size: 27px;
          line-height: 38px;
          text-transform: uppercase;
          color: #092244
        }
        .small-title {
          @include nexaBold;
          font-size: 13px;
          line-height: 18px;
          color: #092244
        }
      }
      .renewalOffer-cnt {
        .renewalOfferTable {
          position: relative;
          display: table;
          width: 100%;
          tr {
            &:nth-child(even) {
              background: rgba(235, 235, 235, 0.80);
            }
            &:first-child {
              text-transform: uppercase;
              td {
                @include nexaBold;
                font-size: 14px;
              }
            }
            td {
              padding: 8px 12px;
              @include nexaBold;
              font-size: 12px;
              line-height: 18px;
              text-align: center;
              color: #092244;
              &.expired {
                color: #FF4B00;
              }
              &:first-child {
                text-align: left;
              }
            }
          }
        }
      }
    }
  }
</style>